// Shared by the marketing session list and detail pages.
export const MARKETING_STATUS_LABELS = {
  gathering: "Gathering info",
  awaiting_feedback: "Awaiting feedback",
  complete: "Complete",
};

export const MARKETING_STATUS_CLASS = {
  gathering: "status-pending",
  awaiting_feedback: "status-sent",
  complete: "status-seen",
};
